import React, { useEffect, useState } from 'react';
import { tvKey } from './tvKeys';
import { LOGO_URL, popNav, popOk, exitTvApp } from './tvAssets';

export function TvExitConfirm({ onCancel }) {
  const [sel, setSel] = useState(0); // 0 = Annuler (défaut), 1 = Quitter

  useEffect(() => {
    const onKey = (e) => {
      const k = tvKey(e);
      if (!k) return;
      e.preventDefault();
      e.stopPropagation();
      if (k === 'left' || k === 'right' || k === 'up' || k === 'down') { popNav(); setSel(s => 1 - s); }
      else if (k === 'ok') { popOk(); if (sel === 1) exitTvApp(); else onCancel(); }
      else if (k === 'back') onCancel();
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [sel, onCancel]);

  const btn = (focused, danger) => ({
    padding: '0.7vw 2.6vw', borderRadius: '2vw', cursor: 'pointer',
    fontSize: '1.05vw', fontWeight: 700, transition: 'transform 0.15s ease, background 0.15s ease',
    transform: focused ? 'scale(1.07)' : 'scale(1)',
    background: focused ? (danger ? '#E9641A' : 'rgba(255,255,255,0.9)') : 'rgba(255,255,255,0.12)',
    color: focused && !danger ? '#11041F' : '#fff',
  });

  return (
    <div data-testid="tv-exit-confirm"
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 90, background: 'rgba(8,3,15,0.96)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <img src={LOGO_URL} alt="Maya+" style={{ height: '2.6vw', marginBottom: '2vw' }} />
      <p style={{ fontSize: '1.7vw', fontWeight: 800, color: '#fff', marginBottom: '0.6vw' }}>Quitter Maya+ ?</p>
      <p style={{ fontSize: '0.95vw', color: 'rgba(255,255,255,0.55)', marginBottom: '2.2vw' }}>
        Votre progression de lecture est enregistrée automatiquement.
      </p>
      <div style={{ display: 'flex' }}>
        <div className="tv-btn" data-testid="tv-exit-cancel" onClick={onCancel} style={btn(sel === 0, false)}>Annuler</div>
        <div style={{ width: '1.4vw', flex: 'none' }} />
        <div className="tv-btn" data-testid="tv-exit-quit" onClick={exitTvApp} style={btn(sel === 1, true)}>Quitter</div>
      </div>
    </div>
  );
}
